import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	deleteErrorTitle: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-error-title.no-translate',
		defaultMessage: 'We couldn’t delete the heartbeat',
		description: `This message will be shown when the request for deleting the heartbeat fails and it will be shown
    on the error flag title`,
	},
	deleteSuccessTitle: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-success-title.no-translate',
		defaultMessage: 'Heartbeat deleted',
		description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`,
	},
	deleteSuccessDescription: {
		id: 'eoc-heartbeats.services.store.delete-heartbeat-success-description.no-translate',
		defaultMessage: 'Nothing to worry about, everything is going great!',
		description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag description`,
	},
	updateAutoCreationSuccessTitle: {
		id: 'eoc-heartbeats.services.store.update-auto-creation-success-title.no-translate',
		defaultMessage: 'Auto-heartbeats {isEnabled, select, true {turned on} other {turned off}}.',
		description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`,
	},
	updateAutoCreationErrorTitle: {
		id: 'eoc-heartbeats.services.store.update-auto-creation-error-title.no-translate',
		defaultMessage:
			'We couldn’t {isEnabled, select, true {turned on} other {turned off}} auto-heartbeats',
		description: `This message will be shown when the request for turning on/off auto-heartbeats and it will be shown
    on the error flag title`,
	},
});

export default messages;
